import { render } from "./Services.vue?vue&type=template&id=33e849ef"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"
script.render = render

export default script